import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export const useEventQueue = create(
	subscribeWithSelector((set, get) => ({
		eventQueue: [],
		eventProcessed: new Set(),
		add: (event) => {
			set({ eventQueue: [...get().eventQueue, event] })
		},
		remove: (event) => {
			set({ eventQueue: get().eventQueue.filter((e) => e.id !== event.id) })
		},
		clearProcessed: () => {
			const { eventQueue, eventProcessed } = get()
			if (eventQueue.length > 0) {
				set({ eventQueue: eventQueue.filter((e) => !eventProcessed.has(e.id)) })
			}
		},
	}))
)
